import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';



import Projects from "../Files/Projects";
import Contact from "../Files/Contact";
import About from "../Files/About";
import Avator from "../Files/Avator";
import Skills from "../Files/Skills";
// import Modules from "../Files/Modules"


const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    maxWidth: 768,
    // margin: theme.spacing(10,0,0,0),
    backgroundColor: theme.palette.background.paper,
    margin: "auto",
    marginTop:"15px",
  },
  Body:{
   display:"flex",
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  typography: {
     margin: theme.spacing(0,0,1,0),
     padding: 0,
  },
head: {
  fontSize:"1.5rem",
  margin: theme.spacing(0,0,1,0),
  fontKerning:"2",
},
  projects: {
   margin: theme.spacing(-2,0,0,0),
  },
  profile: {
    margin: theme.spacing(1, 0),
  },
  tools: {
    margin: theme.spacing(5,0),
  },
 avator: {
   display:"flex",
   justifyContent:"center",
   margin: theme.spacing(6,0,2,0),
 },
 education: {
   margin: theme.spacing(6,0,2,0),
 },
  skills: {
    margin: theme.spacing(5,0),
  },
 hints:{
  margin: theme.spacing(5,0),
 },
  contact: {
    textAlign:"center",
    margin: theme.spacing(4,0,0,0),
  },
}));



/**
 * Body section
 */
const Body = () =>{
 const classes = useStyles();

 return(
   <>
      <div className={classes.Body}>
      <div className={classes.root}>

      {/* ------------------------------------profile----------------------------------------------*/}
          <div className={classes.profile}>
            <p>
              I am a Sales and Marketing student who code <br/> I do Online and Offline marketing campaigns, social media marketing, Google analytics, SEO
            </p>
          </div>
     {/*---------------------------------------Avator----------------------------------- */}
         <Divider variant="middle" />
          <div className={classes.avator} >
             <Avator/>
          </div>
      <Divider variant="middle" />
      {/* ------------------------------------Career Objective----------------------------------------------*/}
          <div className={classes.profile}>
           <u><h2  className={classes.head}> Career Objective</h2></u>
            <p>
A well presented, tech enthusiast and result focused individual with a strong understanding of traditional and digital sales and marketing.
Currently working on personal projects and
Desires to work with a reputable organisation in a suitable position so as to experience uniquely varied and fascinating work environment and industry trends. <br/>
Sure, to be able to make a real contribution to the day-to-day operations of any business. Possesses many transferable skills that can be used in a wide section of settings and industries.

            </p>
          </div>
          <Divider variant="middle" />
      {/* ------------------------------------Education----------------------------------------------*/}
          <div className={classes.education}>
            <u><h2 className={classes.head} >Education  and Training</h2></u>
            <h2 >
              Bachelor of Business Administration with IT, (Sales and Marketing specialization)
             <br/> <b>Tom Mboya University</b>
            </h2>



              <br/>
            <h2 >
               Front End Web Development and Backend Web Development <b>(Self driven!!)</b>
            </h2>
             <br/>
            <h2>
              W3 Schools, YouTube, MDN, Lynda.com, Mediam Articles
            </h2>
          </div>

          <div className={classes.tools}>
            <div>
             <u> <h2 className={classes.head}>Knowlege of;</h2></u>
            </div>
            <div>
             <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript">
               <Chip className={classes.chip}  label="JavaScript" color="secondary" />
             </a>
             <a href="https://reactjs.org/">
                 <Chip className={classes.chip} color="primary" label="React" />
             </a>
             <a href="https://en.wikipedia.org/wiki/CSS" >
               <Chip className={classes.chip} label="CSS3" />
             </a>
             <a href="https://en.wikipedia.org/wiki/HTML5" >
               <Chip className={classes.chip} label="HTML5" />
             </a>
             <a href="https://www.apollographql.com/docs/">
                 <Chip className={classes.chip} color="primary" label="Apollo" />
             </a>
               <Chip className={classes.chip} label="Material UI React" />
             <a href="https://nodejs.org/en/" >
               <Chip className={classes.chip} color="primary" label="Node" />
             </a>
             <a href="//#region ">
               <Chip className={classes.chip}  label="Graphql" color="secondary" />
             </a>
             <a href="https://www.mongodb.com/" >
               <Chip className={classes.chip} color="primary" label="MongoDB" />
            </a>
            </div>
          </div>
         <Divider variant= "fullWidth" />
      {/* ------------------------------------skills and achievement----------------------------------------------*/}
          <div className={classes.skills}>
            <u><h2 className={classes.head}>Skills and achievements</h2></u>
            <Skills/>
          </div>

    {/* ------------------------------------projects----------------------------------------------*/}
          <div className={classes.projects}>
            <div>
                <h2 className={classes.head} style={{marginLeft:"27%", color:"#ff03ee"}}>Tech projects.</h2>
               <Projects/>
            </div>
          </div>

    {/* ------------------------------------Hints----------------------------------------------*/}
        <Divider variant="middle" />
          <div className={classes.hints}>
           <u> <h2 className={classes.head} >Hints about me...</h2></u>
          <About/>
          </div>
    {/* ------------------------------------section4----------------------------------------------*/}
        <Divider variant="middle" />
          <div className={classes.contact}>
          <h2 className="contact">Contact me</h2>
          <Contact/>
          </div>
        </div>
      </div>
  </>
 )
}

export default Body;